<template>
  <span class="ss__avatar__wrapper">
    <img
      ref="img"
      class="ss__avatar"
      :src="src || placeholder"
      @error="onError"
    />
  </span>
</template>

<script>
export default {
  name: 'SsAvatar',

  props: {
    src: String,
    placeholder: {
      type: String,
      default: 'https://cdn-static.sspai.com/ui/otter_avatar_placeholder_240511.png'
    }
  },

  methods: {
    onError (e) {
      this.$refs.img.src = this.placeholder
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/media.styl'
.ss__avatar__wrapper {
  display: inline-flex;
  align-items: center;
  .ss__avatar {
    box-sizing: border-box;
    width: var(--size-SsAvatar, 56px);
    height: var(--size-SsAvatar, 56px);
    border-radius: var(--size-SsAvatar, 56px);
    object-fit: cover;
    border: var(--border-SsAvatar, (1px solid var(--color-imageBorder)));
    background: #fff;
    background-clip: content-box;
  }
}
</style>
